import { lazy } from 'react';
import { CalendarOutlined } from '@ant-design/icons';
import lazyComponent from './lazy';
import { EVENTS_ALLOWED_ROLES } from '../util/stateAccess';

const EventsAdmin = lazy(() => import('../containers/Events'));

const states = [
  {
    key: 'view_events',
    url: 'events',
    name: 'App.Events',
    title: 'Eventos',
    views: {
      'main@App': lazyComponent(EventsAdmin),
    },
    data: {
      nav: {
        type: 'menu',
        sort: 1,
        icon: <CalendarOutlined />,
      },
      roles: EVENTS_ALLOWED_ROLES,
    },
  },
];

export default states;
